import { useEffect, useState } from "react"
import { useRegulatorySession } from "../../providers/regulatoryProvider"
export function usePhysicalResource<T>(key: string, load: (signal: AbortSignal) => Promise<T>) {
  const { sessionKey } = useRegulatorySession()
  const [revision, setRevision] = useState(0)
  const fullKey = `${sessionKey}/${key}/${revision}`
  const [state, setState] = useState<{ key: string; data?: T; error?: Error }>({ key: "" })
  useEffect(() => {
    const controller = new AbortController()
    if (key)
      load(controller.signal)
        .then((data) => {
          if (!controller.signal.aborted) setState({ key: fullKey, data })
        })
        .catch((error) => {
          if (!controller.signal.aborted && error?.name !== "AbortError")
            setState({ key: fullKey, error })
        })
    return () => controller.abort()
    // Callers supply a key for every input that affects the request.
  }, [fullKey])
  return {
    data: state.key === fullKey ? state.data : undefined,
    error: state.key === fullKey ? state.error : undefined,
    loading: !!key && state.key !== fullKey,
    reload: () => setRevision((n) => n + 1),
  }
}
